import { render, staticRenderFns } from "./BackOfLicenseSvg.vue?vue&type=template&id=578ce5d7&"
import script from "./BackOfLicenseSvg.vue?vue&type=script&lang=ts&"
export * from "./BackOfLicenseSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports